// assets
import {
  IconCloudCog,
  IconLayoutDashboard,
  IconActivity,
  IconPlus,
  IconReportAnalytics,
  IconChartHistogram,
  IconFileInvoice,
  IconTool,
  IconUserCog,
  IconNews,
  IconLifebuoy,
  IconTruck
} from '@tabler/icons-react';

import { NavItemType } from 'types';

const icons = {
  IconCloudCog,
  IconLayoutDashboard,
  IconActivity,
  IconPlus,
  IconReportAnalytics,
  IconChartHistogram,
  IconFileInvoice,
  IconTool,
  IconUserCog,
  IconNews,
  IconLifebuoy,
  IconTruck
};

// ==============================|| MENU ITEMS - WEIGHTRAX (PATH B) ||============================== //
//
// Sidebar nav order per Path B Figma (2026-05-09): Dashboard, Activity
// Summary, Add Visit, Reports, Reporting Portal, Invoicing, Maintenance,
// Admin, Application Management, Front Page CMS, Support.
//
// Theme Reference is reachable directly at /theme-reference but is not
// surfaced in the sidebar — it's a meta/dev page, not a destination view.

/// NOTE: THIS IS THE HARDCODED LIST OF MENU ITEMS. THE LIST IS ACTUALLY DRIVEN
/// FROM THE DATABASE. SEE App Management > Menu Items and SQL SPROC SeedModulePagesForTenant
const weightrax: NavItemType = {
  id: 'weightrax',
  title: '',
  type: 'group',
  children: [
    {
      id: 'application-management',
      title: 'App Management',
      type: 'item',
      url: '/application-management',
      icon: icons.IconCloudCog,
      breadcrumbs: false
    },
    {
      id: 'operations',
      title: 'Operations',
      type: 'collapse',
      icon: icons.IconUserCog,
      breadcrumbs: false,
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          url: '/dashboard',
          icon: icons.IconLayoutDashboard,
          breadcrumbs: false
        },
        {
          id: 'activity-summary',
          title: 'Activity Summary',
          type: 'item',
          url: '/activity-summary',
          icon: icons.IconActivity,
          breadcrumbs: false
        },
        {
          id: 'add-visit',
          title: 'Add Visit',
          type: 'item',
          url: '/visits/add',
          icon: icons.IconPlus,
          breadcrumbs: false
        },
        {
          id: 'onsite-vehicles',
          title: 'Onsite Vehicles',
          type: 'item',
          url: '/onsite-vehicles',
          icon: icons.IconTruck,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'reports',
      title: 'Reports',
      type: 'item',
      url: '/reports',
      icon: icons.IconReportAnalytics,
      breadcrumbs: false
    },
    {
      id: 'my-reports',
      title: 'My Reports',
      type: 'item',
      url: '/my-reports',
      icon: icons.IconChartHistogram,
      breadcrumbs: false
    },
    {
      id: 'maintenance',
      title: 'Maintenance',
      type: 'item',
      url: '/maintenance',
      icon: icons.IconTool,
      breadcrumbs: false
    },
    {
      id: 'admin',
      title: 'Admin',
      type: 'collapse',
      icon: icons.IconUserCog,
      breadcrumbs: false,
      children: [
        {
          id: 'admin-companies',
          title: 'Companies',
          type: 'item',
          url: '/admin?tab=companies',
          breadcrumbs: false
        },
        {
          id: 'admin-sites',
          title: 'Sites',
          type: 'item',
          url: '/admin?tab=sites',
          breadcrumbs: false
        },
        {
          id: 'admin-devices',
          title: 'Devices',
          type: 'item',
          url: '/admin?tab=devices',
          breadcrumbs: false
        },
        {
          id: 'admin-device-temperatures',
          title: 'Device Temperatures',
          type: 'item',
          url: '/admin?tab=device-temperatures',
          breadcrumbs: false
        },
        {
          id: 'admin-peripherals',
          title: 'Attached Peripherals',
          type: 'item',
          url: '/admin?tab=peripherals',
          breadcrumbs: false
        },
        {
          id: 'admin-site-settings-page',
          title: 'Site Settings',
          type: 'item',
          url: '/admin?tab=site-settings',
          breadcrumbs: false
        },
        {
          id: 'admin-users',
          title: 'Users',
          type: 'item',
          url: '/admin?tab=users',
          breadcrumbs: false
        },
        {
          id: 'admin-payment-types',
          title: 'Payment Types',
          type: 'item',
          url: '/admin?tab=payment-types',
          breadcrumbs: false
        },
        {
          id: 'admin-report-schedules',
          title: 'Report Schedule',
          type: 'item',
          url: '/admin?tab=report-schedules',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'invoicing',
      title: 'Invoicing',
      type: 'item',
      url: '/invoicing',
      icon: icons.IconFileInvoice,
      breadcrumbs: false
    },
    {
      id: 'cms-editor',
      title: 'CMS Editor',
      type: 'item',
      url: '/cms/editor',
      icon: icons.IconNews,
      breadcrumbs: false
    },
    {
      id: 'support',
      title: 'Support',
      type: 'item',
      url: '/support',
      icon: icons.IconLifebuoy,
      breadcrumbs: false
    }
  ]
};

export default weightrax;
